import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { GitBranch } from 'lucide-react';

const ModelFamilySlide = () => {
  const models = [
    { name: 'DeepSeek-Coder', date: 'Jan 2024', arxiv: '2401.14196', contribution: 'Repository-level code training; foundation for math reasoning', color: 'muted-foreground' },
    { name: 'DeepSeekMath', date: 'Feb 2024', arxiv: '2402.03300', contribution: 'Introduced GRPO; 120B math tokens; 51.7% MATH', color: 'primary', highlight: true },
    { name: 'DeepSeek-V2', date: 'May 2024', arxiv: '2405.04434', contribution: 'MLA attention (93.3% KV cache compression)', color: 'secondary' },
    { name: 'DeepSeek-Prover', date: 'May 2024', arxiv: '2405.14333', contribution: 'Formal theorem proving; 8M synthetic Lean 4 proofs', color: 'muted-foreground' },
    { name: 'DeepSeek-Coder-V2', date: 'Jun 2024', arxiv: '2406.11931', contribution: '338 programming languages; 75.7% MATH', color: 'muted-foreground' },
    { name: 'DeepSeek-Prover-V1.5', date: 'Aug 2024', arxiv: '2408.08152', contribution: 'RLPAF (RL from proof assistant feedback)', color: 'muted-foreground' },
    { name: 'DeepSeek-V3', date: 'Dec 2024', arxiv: '2412.19437', contribution: '14.8T tokens; Multi-Token Prediction; distillation from R1', color: 'accent' },
    { name: 'DeepSeek-R1', date: 'Jan 2025', arxiv: '2501.12948', contribution: 'Pure RL reasoning emergence; GRPO at scale', color: 'primary', highlight: true },
  ];

  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="From code to reasoning: the evolution of DeepSeek's model family"
      >
        DeepSeek Model Family Evolution
      </SlideTitle>
      
      <SlideContent>
        <div className="slide-card overflow-hidden">
          <div className="flex items-center gap-2 mb-4">
            <GitBranch className="w-5 h-5 text-primary" />
            <h3 className="font-heading font-semibold text-foreground">Timeline</h3>
          </div>
          
          <div className="overflow-x-auto">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Model</th>
                  <th>Date</th>
                  <th>arXiv</th>
                  <th>Key Contribution</th>
                </tr>
              </thead>
              <tbody>
                {models.map((model, index) => (
                  <tr key={index} className={model.highlight ? 'bg-primary/5' : ''}>
                    <td>
                      <span className={`font-semibold ${model.highlight ? 'text-primary' : 'text-foreground'}`}>
                        {model.name}
                      </span>
                    </td>
                    <td className="text-muted-foreground font-mono text-sm">{model.date}</td>
                    <td>
                      <code className="text-xs px-2 py-1 rounded bg-muted/50 text-muted-foreground">
                        {model.arxiv}
                      </code>
                    </td>
                    <td className="text-sm text-muted-foreground">
                      {model.highlight ? (
                        <span className="text-primary">{model.contribution}</span>
                      ) : (
                        model.contribution
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          <div className="p-4 rounded-xl bg-primary/10 border border-primary/20">
            <p className="text-sm">
              <strong className="text-primary">GRPO Origin:</strong>
              <span className="text-muted-foreground"> First introduced in DeepSeekMath (Feb 2024), then scaled to R1</span>
            </p>
          </div>
          <div className="p-4 rounded-xl bg-accent/10 border border-accent/20">
            <p className="text-sm">
              <strong className="text-accent">Code → Math:</strong>
              <span className="text-muted-foreground"> DeepSeekMath was initialized from Coder-Base, proving code training enhances reasoning</span>
            </p>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default ModelFamilySlide;
